import InputTemplate from '../../html/components/input.html'
import InputGroupTemplate from '../../html/components/input-group.html'

import Component from '../shared/component'

import {FormControlMixin} from './form'

export const Input = Component('v-input', {
  inheritAttrs: false,
  mixins: [
    FormControlMixin('input')
  ],
  template: InputTemplate,
  props: {
    name: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator (value) {
        switch (value) {
          case 'text':
          case 'textarea':
          case 'search':
          case 'email':
          case 'url':
          case 'tel':
          case 'password':
          case 'number':
          case 'date':
          case 'month':
          case 'week':
          case 'time':
            return true
          default:
            return false
        }
      }
    },
    icon: {
      type: String,
      default: null
    },
    autosize: {
      type: Boolean,
      default: false
    },
    rowsMin: {
      type: [Number, String],
      default: 4
    },
    rowsMax: {
      type: [Number, String],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    warning: {
      type: Boolean,
      default: false
    },
    iconColor: {
      type: String,
      default: null,
      validator (value) {
        switch (value) {
          case '':
          case 'black':
          case 'gray':
          case 'white':
          case 'teal':
          case 'blue':
          case 'green':
          case 'green-dark':
          case 'red':
          case 'red-dark':
          case 'orange':
          case 'orange-dark':
            return true
          default:
            return false
        }
      }
    },
    iconSize: {
      type: [
        String,
        Number
      ],
      default: null
    }
  },
  data () {
    return {
      height: null
    }
  },
  computed: {
    typeClass () {
      return `is-${this.type}`
    },

    minHeight () {
      if (!this.rowsMin) {
        return
      }

      return 10 + (18 * parseInt(this.rowsMin))
    },

    maxHeight () {
      if (!this.rowsMax) {
        return
      }

      return 10 + (18 * parseInt(this.rowsMax))
    },

    style () {
      return {
        height: this.height && `${this.height}px`,
        minHeight: this.minHeight && `${this.minHeight}px`,
        maxHeight: this.maxHeight && `${this.maxHeight}px`
      }
    }
  },
  mounted () {
    this.resize()
  },
  methods: {
    input ({target}) {
      let {value} = target

      switch (this.type) {
        case 'number':
          value = Number(value)
      }

      this.change(value)
    },

    resize () {
      const {textarea} = this.$refs

      if (!textarea || !this.autosize) {
        return
      }

      const previous = this.height

      this.height = null

      this.$nextTick(() => {
        this.height = textarea.scrollHeight

        if (this.height !== previous) {
          this.$emit('resize')
        }
      })
    }
  }
})

export const InputGroup = Component('v-input-group', {
  template: InputGroupTemplate
})
